import React, { useState } from "react"

import Skeleton from "@material-ui/lab/Skeleton"

import { IMessageExtraData } from "@/protocols/channel"

import useStyles from "@/components/Messages/LocationMessage/styles"

type LocationMessageProps = {
	extraData: IMessageExtraData
}

export const LocationMessageContent: React.FC<LocationMessageProps> = (props) => {
	const { extraData } = props
	const classes = useStyles()
	const [loaded, setLoaded] = useState(false)

	const locationData = extraData?.locationMessage

	if (!locationData) {
		return null
	}

	const latitudeAsNumber = Number(locationData.latitude)
	const longitudeAsNumber = Number(locationData.longitude)
	const MAP_VISIBLE_AREA_DEGREE_MARGIN = 0.01

	const mapsUrl = `https://www.google.com/maps?q=${latitudeAsNumber},${longitudeAsNumber}`

	const iframeSrc = `https://www.openstreetmap.org/export/embed.html?bbox=${longitudeAsNumber - MAP_VISIBLE_AREA_DEGREE_MARGIN},${latitudeAsNumber - MAP_VISIBLE_AREA_DEGREE_MARGIN},${longitudeAsNumber + MAP_VISIBLE_AREA_DEGREE_MARGIN},${latitudeAsNumber + MAP_VISIBLE_AREA_DEGREE_MARGIN}&layer=mapnik&marker=${latitudeAsNumber},${longitudeAsNumber}`

	return (
		<a
			href={mapsUrl}
			target="_blank"
			rel="noopener noreferrer"
			className={classes.container}
		>
			{!loaded && (
				<Skeleton variant="rect" className={classes.loadingOverlay} />
			)}
			<iframe
				src={iframeSrc}
				className={classes.map}
				title="Localização"
				onLoad={() => setLoaded(true)}
			/>
		</a>
	)
}
